import React from 'react'
import { Link } from 'react-router-dom'

import { Title as TitleComponent } from './styles'
import SendGTAGEvent from '../../utils/sendGTAGEvent';

interface iTitleProps {
    className?: string;
}

const Title: React.FC<iTitleProps> = ({ className }) => (
    <TitleComponent className={className} onClick={() =>
        SendGTAGEvent(
            'botao_titulo_lojinha',
            'Produtos',
            'Clicou no botão de navegação +Lojinha',
        )}>
        <Link to="/products">
            +<strong>Lojinha</strong>
        </Link>
    </TitleComponent>
)

export default Title